import React, {useState} from 'react'

import './searcher.css'

import {Button, Form, Input, TimePicker, DatePicker, InputNumber} from 'antd'

const dayjs = require('dayjs')

const format = 'HH:mm';

const Searcher = ({getAvailableRooms, values}) => {
	const [required, setRequired] = useState({description: false, email: false, date: false, time: false, occupants: false})
	
	const disabledDate = (current) => {
		return current < dayjs().startOf('day')
	}
	
	const handleFinish = async (values) => {
		let requiredItem = required
		let requestAvailable = true
		for(const item of Object.keys(values)){
			if(!values[item]){
				requiredItem = {...requiredItem, [item]: true}
				requestAvailable = false
			} else {
				requiredItem = {...requiredItem, [item]: false}
			}
		}
		setRequired(requiredItem)
		if(requestAvailable){
			await getAvailableRooms(values)
		}
		dayjs(values.date).format('YYYY-MM-DD')
	}
	
	return (
		<div className="mainWrapper">
			<div className='title'>
				RESERVA DE SALAS
			</div>
			<div className="formWrapper">
				<Form
					name="bookingRoom"
					onFinish={handleFinish}
					style={{color: '#1E7988'}}
					layout="vertical"
					initialValues={{
						date: values.date ? values.date : dayjs(),
						time: values.time.length ? values.time : [dayjs(), dayjs().add(1, 'hour')],
						description: values.description ? values.description : null,
						occupants: values.occupants ? values.occupants : 1,
						email: values.email ? values.email : null,
					}}
				>
					<div className="wrapperDateTime">
						<Form.Item
							label="FECHA"
							name="date"
							style={{width: '40%'}}
						>
							<DatePicker 
								suffixIcon={null}
								allowClear={false}
								format={'DD/MM/YY'}
								className={required.date ? 'required' : ''}
								disabledDate={disabledDate}
							/>
						</Form.Item>
						<Form.Item
							label="HORA"
							name="time"
							style={{width: '60%'}}
						>
							<TimePicker.RangePicker 
								format={format}
								suffixIcon={null} 
								allowClear={false}
								className={required.time ? 'required' : ''}
								disabledTime={RangeDisabledTime}
								needConfirm={false}
							/>
						</Form.Item>
					</div>
					<div className="wrapperInputs">
						<Form.Item
							label="MOTIVO"
							name="description"
						>
							<Input placeholder="¿Por qué se reserva la sala?" className={required.description ? 'required' : ''} />
						</Form.Item>
						<Form.Item
							label="OCUPANTES"
							name="occupants"
						>
							<InputNumber min={1} className={required.occupants ? 'required' : ''} style={{width: '100%', background: 'transparent', border: '0px solid #1E7988', borderRadius: '0px'}}/>
						</Form.Item>
						<Form.Item
							label="EMAIL"
							name="email"
						>
							<Input placeholder="Introduzca el email" type="email" className={required.email ? 'required' : ''} />
						</Form.Item>
					</div>
					<div className="buttonCheckAvailable">
						<Form.Item>
							<Button htmlType="submit">
								VER DISPONIBILIDAD
							</Button>
						</Form.Item>
					</div>
				</Form>
			</div>
		</div>
	)
}

const RangeDisabledTime = (now, type) => {
	const trueNow = dayjs()
	const disabledHours = () => {
		const hours = []
	
		for (var i = 0; i < trueNow.hour(); i++) {
			 hours.push(i)
		}
		
		return hours
	}
	const disabledMinutes = (selectedHour) => {
		const minutes = []
		
		if(selectedHour === trueNow.hour()){
			for(var i = 0; i < now.minute(); i++){
				minutes.push(i)
			}
		}
		
		return minutes
	}
	return {disabledHours, disabledMinutes}
}

export default Searcher